module.exports = __webpack_public_path__ + "img/documentation.c9d57e40.svg";